import { FileCheck } from 'lucide-react';
import { AssessmentCompletedEvent as AssessmentCompletedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: AssessmentCompletedEventType;
}

export default function AssessmentCompletedEvent({ event }: Props) {
  return (
    <EventShell
      color="indigo"
      icon={<FileCheck className="w-3.5 h-3.5" />}
      title="Assessment Completed"
      timestamp={event.created_at}
    >
      {event.payload.assessment_name && <p>{event.payload.assessment_name}</p>}
      {event.payload.summary && <p>{event.payload.summary}</p>}
    </EventShell>
  );
}
